// ===== FILE: src/hooks/useContractorCategories.ts =====
import { useState, useEffect } from 'react';
import { contractorAPI, CategoryWithCount } from '../services/contractorService';

interface UseContractorCategoriesReturn {
  categories: CategoryWithCount[];
  loading: boolean;
  error: string | null;
  topCategories: CategoryWithCount[];
  refetch: () => void;
}

export const useContractorCategories = (topCount = 10): UseContractorCategoriesReturn => {
  const [categories, setCategories] = useState<CategoryWithCount[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await contractorAPI.getCategoriesWithCounts();
      setCategories(response.data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch categories');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const topCategories = categories.slice(0, topCount);

  return {
    categories,
    loading,
    error,
    topCategories,
    refetch: fetchCategories
  };
};